import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"
import { showAlertModal } from "../lib/custom_confirm"

// Instant-save Shown/Hidden toggle for one Product Pages tile (admin Agent
// Website settings). Track + status-label color is pure CSS (gl-toggle--switch
// red-off / green-on via :has(:checked)); this controller persists the flip
// and keeps the text label in sync. On failure it reverts the switch so the UI never
// misrepresents the saved state; a server-provided reason (e.g. the
// recruiting completeness gate) renders in the styled alert modal so the
// admin learns WHAT to fix, not just that the flip failed.
export default class extends Controller {
  static targets = ["input", "label"]
  static values = { url: String, slug: String, title: String }

  async toggle() {
    const enabled = this.inputTarget.checked
    this.setLabel(enabled)
    this.inputTarget.disabled = true

    const body = new FormData()
    body.append("product_slug", this.slugValue)
    body.append("enabled", enabled ? "1" : "0")

    try {
      const response = await patch(this.urlValue, { body, responseKind: "json" })
      if (response.ok) {
        window.showToast?.(`${this.pageName} is now ${enabled ? "shown" : "hidden"}`, "bg-success")
      } else {
        this.revert(enabled, await this.errorMessage(response))
      }
    } catch {
      this.revert(enabled)
    } finally {
      this.inputTarget.disabled = false
    }
  }

  async errorMessage(response) {
    try {
      return (await response.json)?.error
    } catch {
      return null
    }
  }

  revert(attempted, reason = null) {
    this.inputTarget.checked = !attempted
    this.setLabel(!attempted)
    if (reason) {
      showAlertModal(reason, { title: this.pageName })
    } else {
      window.showToast?.(`Failed to update ${this.pageName}`, "bg-danger")
    }
  }

  get pageName() {
    return this.hasTitleValue && this.titleValue ? `${this.titleValue} page` : "Page"
  }

  setLabel(enabled) {
    this.labelTarget.textContent = enabled ? "Shown" : "Hidden"
  }
}
